import { Component, input, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'csl-count-badge',
  standalone: true,
  imports: [],
  templateUrl: './count-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './count-badge.component.css',
})
export class CountBadgeComponent {
  value = input<number>();
}
